import { isNull } from 'lodash';
import { AllocationName, FinancialStatementSmall } from 'api';
import { CapTableVersion } from 'common/types/company';
import { DropDownChoice } from 'layouts/Main/components/ExcelExportDialog/types';
import { VERSION_NAME_PREFIX } from 'pages/ValuationsAllocation/common/constants/valuations';
import { formatDateView, getBooleanValue } from 'utilities';

const parseDataForDropDowns = (
  capTableVersions: CapTableVersion[],
  financialStatementVersion: FinancialStatementSmall[],
  allocationVersions: AllocationName[]
) => {
  const captables: DropDownChoice<CapTableVersion>[] =
    capTableVersions && capTableVersions.length > 0
      ? capTableVersions.map(capTable => ({ ...capTable, is_main: getBooleanValue(capTable.is_primary) }))
      : [];
  const financial_statements: DropDownChoice<FinancialStatementSmall>[] =
    financialStatementVersion && financialStatementVersion.length > 0
      ? financialStatementVersion.map(fs => ({
        ...fs,
        is_main: isNull(fs.versioning),
        name: !fs.versioning ? 'Primary Financial Statement' : fs.name,
      }))
      : [];
  const valuations: DropDownChoice<AllocationName>[] =
    allocationVersions && allocationVersions.length > 0
      ? allocationVersions.map(alloc => ({
        ...alloc,
        id: alloc.valuation,
        is_main: alloc.is_main || alloc.version === 1 || allocationVersions.length === 1,
        name: alloc.name.includes(VERSION_NAME_PREFIX)
          ? alloc.name
          : `${VERSION_NAME_PREFIX} ${alloc.version} - ${formatDateView(alloc.name)}`,
      }))
      : [];
  return { captables, financial_statements, valuations };
};

export default parseDataForDropDowns;
